import { RemovableTag } from '@monash/portal-react';
import cs from '../shared.module.scss';
import { LINKS_FILTER_FULL_TEXT } from '../../../../link-form/filters/constants';
import {
  NULL_COHORTS_ID,
  NULL_COHORTS_TEXT,
} from '../../../utils/get-filter-options';

const FULL_TEXT = {
  ...LINKS_FILTER_FULL_TEXT,
  [NULL_COHORTS_ID]: NULL_COHORTS_TEXT,
};

const CohortFiltersTags = ({ options, selectedValues, onRemove }) => {
  const extractedOptions = options.reduce((acc, location) => {
    return [...acc, ...location.options];
  }, []);

  return extractedOptions
    .filter((opt) => selectedValues?.includes(opt.value))
    .map((opt) => (
      <RemovableTag
        key={opt.value}
        className={cs.tag}
        text={FULL_TEXT[opt.value]}
        size="large"
        onRemove={() => onRemove(opt.value)}
      />
    ));
};

export default CohortFiltersTags;
